var map = {
	"./de-DE/welcome.json": [
		23069,
		7244
	],
	"./en-AU/welcome.json": [
		72789,
		2768
	],
	"./en-CA/welcome.json": [
		67780,
		8255
	],
	"./en-GB/welcome.json": [
		17360,
		680
	],
	"./en-US/welcome.json": [
		91834,
		5067
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 15923;
module.exports = webpackAsyncContext;